module.exports = __webpack_public_path__ + "img/833b9ca.svg";